import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ConfigServiceProvider} from "../config-service/config-service";
import {Device} from "@ionic-native/device";
import {App, Platform} from "ionic-angular";
import {PlatformService} from "../platform-service/platform-service";

/*
  Generated class for the AnalyticsServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AnalyticsServiceProvider {
  enterTime = {};
  screenTimings = {};
  GA_ENDPOINT = 'https://www.google-analytics.com/collect';
  TID = 'UA-75763607-2';
  AN = this.configService.getConfig('application');
  AV = this.configService.getConfig('version');
  AID = 'com.visuu.' + this.configService.getConfig('application') + '.app';
  AAID = 'com.visuu.' + this.configService.getConfig('application') + '.installer';

  constructor(public http: HttpClient, private app: App, private configService: ConfigServiceProvider, private device: Device, private platform: Platform, private platformService: PlatformService) {
    this.collectGoogleAnalyticsData();
  }

  sendAnalytics(cd) {
    let cid = this.getClientId();
    if (cid) {
      let xhr = new XMLHttpRequest();
      let body = 'v=1&t=screenview&tid=' + this.TID + '&cid=' + cid + '&an=' + this.AN + '&aid=' + this.AID + '&av=' + this.AV + '&aaid=' + this.AAID + '&cd=' + cd;

      xhr.open('POST', this.GA_ENDPOINT, true);
      xhr.send(body);
    }
  }

  private getClientId() {
    if (this.device && this.device.uuid) {
      return this.device.uuid;
    }
    const gaCookie = document.cookie['_ga']
    return gaCookie ? gaCookie.split(".").skip(2).join(".") : null
  }

  sendScreenData(player) {
    let cid = this.getClientId();
    if (cid) {
      Object.getOwnPropertyNames(this.screenTimings).forEach((value, index, array) => {
        let xhr = new XMLHttpRequest();
        let body = 'v=1&t=screenview&tid=' + this.TID + '&cid=' + cid + '&an=' + this.AN + '&aid=' + this.AID + '&av=' + this.AV + '&aaid=' + this.AAID + '&cd=' + value + '&cd1=' + this.configService.getConfig('application') + ':' + player.id + '&time=' + this.screenTimings[value];

        xhr.open('POST', this.GA_ENDPOINT, true);
        xhr.send(body);
        this.screenTimings[value] = 0;
      });
    }
  }

  setTimeTracking(stateName) {
    this.enterTime[stateName] = new Date();
  }


  stopTimeTracking(stateName) {
    let timeOnScreen = Number(new Date()) - this.enterTime[stateName];
    let currentTime = this.screenTimings[stateName] || 0;
    this.screenTimings[stateName] = currentTime + timeOnScreen;
  }

  collectGoogleAnalyticsData() {
    this.app.viewDidEnter.subscribe(ev => {
      if (String(ev.id).includes('Page')) {
        this.setTimeTracking(ev.id)
      }
    });
    this.app.viewDidLeave.subscribe(ev => {
      if (String(ev.id).includes('Page'))
        this.stopTimeTracking(ev.id);
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/core/services/analytics-service/analytics-service.ts